import '@zebra-fed/icons/Enterprise/index.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router";
import styled from 'styled-components';
import { Button, Dropdown, Icon } from '@zebra-fed/zds-react-desktop';
import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';
import { ContentWrapper, PageTitle } from '../../styled-components/shared';
import { useTranslation } from "react-i18next";
import { CircularProgress } from '@material-ui/core';
import SummaryContainer from "./Components/SummaryContainer"
import DropdownCustom from '../../components/DropdownCustom';
import BottomNavLinks from '../../components/BottomNavLinks';
import { userJustManager } from '../../data/userUtil';

const firestore = app.firestore();


const ButtonDiv = styled.div`
  display: flex;
  @media screen and (max-width: 750px) {
    flex-direction: column;
  }
`;

const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
`;

const StyledHeader = styled(PageTitle)`
  // min-width: 1020px;
`;

const TableHeader = styled.h1`
  font-size: 20px;
`;

const ContainerBox = styled.div`
  width: 98%;
  padding: 1%;
  float: left;
  height: auto;
  @media screen and (max-width: 750px) {
    margin-top: 10px;
  }
`;

const SiteData = styled.div`
    display: flex;
    margin-bottom: 8px;
    color: black;  
`;

const SiteNameLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const StyledTextField = styled.div`
  margin-left: 10px;
  font-size: 16px;
`;

const PageTitleTop = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 27px;
  color: #007ABA;
  width: 100%;
  @media screen and (max-width: 700px){
    flex-direction: column;
  }
`;

export default function AdminManagerSummaryBoard(props) {

  const context = useContext(AuthContext);
  const { t } = useTranslation();
  const history = useHistory();
  const { listDropDown, setListDropDown } = props;
  const [loggedInUser, setLoggedInUser] = useState(null);
  let [dropDownvalue, setDropdownValue] = useState(null);
  const [siteData, setSIteData] = useState([]);
  const [allSiteNames, setAllSiteNames] = useState([])
  const [sitesOld, setSitesOld] = useState([{ label: "All Devices", value: "All Devices" }])
  const DEFAULT_ROWS_PER_PAGE = 10;
  const [sitesFilterVal, setSitesFilterVal] = useState({})
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [isLoading, setIsLoading] = useState(false);
  const isManager = userJustManager(context.currentUser.claims)
   
  let siteNameAssigned = "";
  let defaultManagerSite 
  if (isManager) {
    siteNameAssigned = context.currentUser.claims.siteArr[0];
    siteNameAssigned = siteNameAssigned.toUpperCase();
    defaultManagerSite = {label: siteNameAssigned, value: siteNameAssigned}
  }

  const [siteDefaultValue, setSiteDefaultValue] = useState(!isManager ? { label: "All Devices", value: "All Devices" } : defaultManagerSite)

  useEffect(() => {
    setLoggedInUser(context.currentUser.email);
    getSitesData(pageSize);
    setListDropDown(null);
    props.setTitle("");
    console.log('sessionStorage.getItem("selectedSite")', sessionStorage.getItem("selectedSite"))
    if (sessionStorage.getItem("selectedSite") != null && sessionStorage.getItem("selectedSite") != "ALL SITES") {
      setSiteDefaultValue({ label: sessionStorage.getItem("selectedSite"), value: sessionStorage.getItem("selectedSite") })
      setDropdownValue(sessionStorage.getItem("selectedSite"))
    } else {
      if(isManager)
        setDropdownValue(siteNameAssigned)
      else
        setDropdownValue("All Devices")
      
    }
  }, []);


  async function getSitesData(currentPageSize) {
    setIsLoading(true)
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    let companyID = context.currentUser.claims.companyID;
    let sites = [];
    let finalSitesArray = [];
    let finalSitesArrayNew = allSiteNames;

    if(isManager){
       context.currentUser.claims.siteArr.forEach(el=>
        {
          finalSitesArray.push({name:el})
          finalSitesArrayNew.push({ label: el, value: el });
        }
        );
    }else{
      sites = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('SiteLocations')
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
      Object.keys(sites).forEach(site => {
        finalSitesArray.push({ name: sites[site].siteName }) // Exact key name picked from sitesLocations collections.
      });
      finalSitesArray.unshift({ name: 'Unassigned Devices' });
      finalSitesArray.unshift({ name: 'All Devices' });
    Object.keys(sites).forEach(site => {
        finalSitesArrayNew.push({ label: sites[site].siteName, value: sites[site].siteName })
      })
      finalSitesArrayNew.unshift({ label: 'Unassigned Devices', value: 'Unassigned Devices' });
      finalSitesArrayNew.unshift({ label: 'All Devices', value: 'All Devices' });
    }
    setSIteData(finalSitesArray);     
    setAllSiteNames(finalSitesArrayNew)
    setSitesOld(finalSitesArrayNew)
    // setAllSiteNames(sites)

    setIsLoading(false);
  }

  function siteChange(event) {
    setDropdownValue(siteData[event]?.name)
  }

  function redirectOnClick(routePath) {
    history.push({
      pathname: `/dashboard/${routePath}`
    })
  }

  function onFilterChange(e, filterName) {
    console.log('site optoin changed mmm')
    let opted = e.target.value;
    if (filterName === 'SITES_FILTER') {
      console.log('e.target---> ', e.target)
      setSitesFilterVal(e.target)
      // setAllSiteNames(sitesOld)
      setDropdownValue(e.target?.value)
      sessionStorage.setItem("selectedSite", e.target?.value);
      // setSite("selecctedSiteName", e.target?.value)
    }
  }

  function getSelectInputSearch(rawInput, type) {
    if (type === 'ENTERHIT') {

      searchSiteName(rawInput)

    }
    // console.log('type :', type);
    // console.log('rawInput :', rawInput);
    // if ( type === 'ENTERHIT') {

    //   let customFil = allSiteNames.filter(
    //     value => {
    //       return (
    //         value
    //           .value
    //           .toLowerCase() ===
    //         (rawInput.toLowerCase())
    //       );
    //     });
    //   if (customFil.length === 0) {
    //     searchSiteName(rawInput)
    //   }
    //   else {
    //     setAllSiteNames(customFil)
    //   }
    // } else if ( type === 'EMPTY' ) {
    //   setAllSiteNames(sitesOld)
    // }
  }

  async function searchSiteName(value) {
    let companyID = context.currentUser.claims.companyID;
    let sites = [];
    setIsLoading(true);
    sites = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('siteName')
        .startAt(value.toUpperCase()).endAt(value.toUpperCase() + "\uf8ff")
        .limit(10)
        .get()
    ).docs.map((doc) => doc.data());

    let finalSitesArray = [
      { label: "All Devices", value: "All Devices" },
      { label: 'Unassigned Devices', value: 'Unassigned Devices' }
    ]
    sites.forEach(element => {
      finalSitesArray.push({ label: element.siteName, value: element.siteName })
    });
    setAllSiteNames(finalSitesArray)
    setIsLoading(false);

  }

  function customFilterSearch(option, rawInput) {
    return allSiteNames;
  }

  return (
    <>
      <ContentWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1', position: 'relative' }}>
        <PageTitleTop >
          {t('summaryDashboard')}
        </PageTitleTop>
        <div
          // style={{display: 'flex', justifyContent: 'space-between'}}
          className='device-details-button-row'>
          {
            siteData.length > 0 && (
              <span className='devices-dash-drop'>
                <DropdownCustom
                  selectOpts={allSiteNames}
                  // defaultValue={allSiteNames[0]}
                  onChange={(e) => onFilterChange(e, 'SITES_FILTER')}
                  // // resetSelect={resetCusSelect}
                  selectVal={sitesFilterVal.label ? sitesFilterVal : siteDefaultValue
                  }
                  isSearchable={true}
                  onSearchInpChange={getSelectInputSearch}
                  isLoading={isLoading}
                  customFilterOption={customFilterSearch}
                />
              </span>
            )}
          {siteData.length > 0 && dropDownvalue && (
            <ButtonDiv className='summary-button-div'>
              <Button
                type="primary"
                dense={true}
                style={{ margin: '10px', display:'flex' }}
                onClick={() => redirectOnClick('sites')}
              >
                {t('viewSites')}
              </Button>

              <Button
                type="primary"
                dense={true}
                style={{ margin: '10px' }}
                onClick={() => redirectOnClick('aps')}
              >
                {t('viewAps')}
              </Button>
            </ButtonDiv>)
          }
        </div>
        <ContainerBox>
          {isLoading && <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
            <CircularProgress />
          </div>}
          {dropDownvalue && (
            <SummaryContainer
              containerOf={"Mobile"}
              sitevalue={dropDownvalue}
              selectedTitle={props?.selectedTitle}
              setTitle={props?.setTitle}
              loading={isLoading}
              getSummaryCount = {()=>{}}
            />
          )}
        </ContainerBox>
        <BottomNavLinks />
      </ContentWrapper>
    </>
  );
}